import { darken, lighten, styled } from "@mui/material/styles";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Autocomplete from "@mui/material/Autocomplete";
import { isIOS, isIntegrated } from '../helpers/browser';
import MuiAppBar from '@mui/material/AppBar';
import { SelectElement, TextareaAutosizeElement, PasswordElement, TextFieldElement, DatePickerElement } from "react-hook-form-mui";
const drawerWidth = 240;
export const lightTheme = {
    palette: {
        mode: 'light',
        white: {
            main: '#fff',
            light: '#fff',
            dark: '#fff',
            contrastText: '#ccc'
        },
        background: {
            default: '#fff'
        },
        primary: {
            main: isIntegrated ? '#1C9BCE' : '#7c2b83',
            // contrastText: '#7c2b83'
        },
        secondary: {
            main: '#1e8ca5',
            // contrastText: '#7c2b83'
        }
    },
    // components: {
    //     MuiButton: {
    //         styleOverrides: {
    //             root: {
    //                 "&.MuiButton-contained": {
    //                     color: '#fff'
    //                 }
    //             }
    //         }
    //     }
    // }
};
export const darkTheme = {
    palette: {
        mode: 'dark',
        background: {
            default: '#282828'
        },
        primary: {
            main: '#1369be',
            // contrastText: '#fafafa'
        },
        secondary: {
            main: '#328ce7',
            // contrastText: '#fafafa'
        }
    }
};
export const yiiTheme = {
    palette: {
        mode: 'light',
        white: {
            main: '#fff',
            light: '#fff',
            dark: '#fff',
            contrastText: '#ccc',
        },
        background: {
            default: '#fff'
        },
        primary: {
            main: '#1C9BCE',
        },
        secondary: {
            main: '#1e8ca5',
        }
    },
    components: {
        MuiPaper: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    padding: '1em 0 !important',
                    "&.MuiPaper-elevation2": {
                        boxShadow: 'none !important',
                        borderRadius: '0 !important',
                        "& > .MuiBox-root": {
                            boxShadow: 'none !important',
                            borderTop: '#111 1px solid'
                        }
                    },
                    "& .MuiTableRow-head": {
                        boxShadow: 'none !important',
                        "& .MuiTableCell-head:last-of-type": {
                            "& .Mui-TableHeadCell-Content": {
                                justifyContent: 'flex-end'
                            }
                        }
                    },
                    "& .MuiTableFooter-root": {
                        "& tr:nth-child(2)": {
                            display: 'none !important'
                        }
                    },
                    "& .MuiTableHead-root": {
                        "& .MuiTableCell-head": {
                            borderBottom: '1px solid #111 !important'
                        }
                    },
                    "& .MuiTableBody-root": {
                        "& .MuiTableRow-root": {
                            backgroundColor: '#f9f9f9 !important',
                            "& .MuiTableCell-root": {
                                padding: '0.5rem 1rem'
                            },
                            "& .MuiTableCell-root:last-of-type": {
                                textAlign: 'right'
                            }
                        },
                        "& .MuiTableRow-root:nth-child(even)": {
                            backgroundColor: '#fff !important'
                        }
                    }
                }
            }
        },
        MuiStack: {
            styleOverrides: {
                root: {
                    "& .MuiFilter-root": {
                        "& > div > div": {
                            "& .MuiFormControl-root": {
                                "& label": {
                                    display: "block",
                                    float: 'none',
                                    width: '180px',
                                },
                                "& > div": {
                                    marginLeft: "0",
                                    display: 'inline-flex'
                                },
                                "& .MuiInputAdornment-outlined button": {
                                    position: 'relative',
                                    right: '-10px',
                                    top: 0
                                }
                            }
                        }
                    },
                    "& .MuiFormControl-root.MuiFilter-root": {
                        "& label": {
                            display: "block",
                            float: 'none',
                            width: '180px',
                        },
                        "& > div": {
                            marginLeft: "0",
                            display: 'inline-flex'
                        },
                        "& .MuiInputAdornment-outlined button": {
                            position: 'relative',
                            right: '-10px',
                            top: 0
                        }
                    }
                }
            }
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    "&.IntegratedFieldCheckbox": {
                        backgroundColor: '#c00',
                        "& .MuiFormControl-root": {
                            clear: 'both',
                            "& > div": {
                                marginLeft: 0,
                                "& label": {
                                    width: '100%'
                                }
                            }
                        },
                        "& p": {
                            clear: 'both'
                        }
                    }
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    display: 'block',
                    "&.MuiIntegratedCheckbox": {
                        "& > div": {
                            marginLeft: 0
                        },
                        "& label": {
                            float: 'none'
                        }
                    },
                    "&.MuiDatePicker": {
                        width: "100px",
                        "& > div": {
                            marginLeft: 0
                        }
                    },
                    "&.MuiNoLabel": {
                        float: "left",
                        "& > div": {
                            marginLeft: 0
                        }
                    },
                    "& label": {
                        display: "block",
                        float: 'left',
                        width: '180px',
                        transform: "none",
                        color: "#1e1e1e !important",
                        maxWidth: '100%',
                        textOverflow: 'clip',
                        whiteSpace: 'initial'
                    },
                    "& > div": {
                        display: "block",
                        marginLeft: "190px",
                        borderRadius: '0.1em',
                        backgroundColor: '#fff',
                        borderColor: '#bbb'
                    },
                    "& input": {
                        padding: '0.4em 0.3em 0.5em'
                    },
                    "& input:focus": {
                        outlineColor: 'rgba(0,0,0,0.3)'
                    },
                    "& fieldset": {
                        top: 0
                    },
                    "& .Mui-focused fieldset": {
                        borderColor: 'rgba(0,0,0,0.3) !important',
                        borderRadius: '3px'
                    },
                    "& fieldset legend": {
                        display: 'none'
                    },
                    "& .MuiSelect-select": {
                        padding: '6px'
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#bbb !important",
                        borderWidth: '1px !important'
                    },
                    "& .MuiInputAdornment-outlined button": {
                        position: 'absolute',
                        right: '-24px',
                        top: 0
                    }
                }
            }
        }
    }
};
export const HorizontalContainer = styled(Box)(({ theme }) => ({
    maxHeight: 'calc(100vh - 144px)',
    width: 'fit-content',
    display: 'grid',
    gridTemplateColumns: '30px auto',
    overflowX: 'scroll',
}));
export const VerticalContainer = styled(Box)(({ theme }) => ({
    overflowY: 'scroll',
    height: '100%',
    display: 'grid',
    gridTemplateRows: '50px auto'
}));
export const ThemedAppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => !['open', 'ismobile'].includes(prop),
})(({ theme, open, ismobile }) => (Object.assign({ transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }) }, (open && {
    width: `calc(100% - ${ismobile ? drawerWidth : 0}px)`,
    marginLeft: `${ismobile ? drawerWidth : 0}px`,
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
}))));
export const ThemedToolbar = styled(Toolbar)(({ theme }) => ({
    paddingRight: theme.spacing(1),
    '@media all': {
        paddingRight: theme.spacing(1),
    }
}));
export const ThemedDialog = styled(Dialog)(({ theme }) => ({
    maxWidth: '700px',
    "& .MuiDialog-paper": {
        background: theme.palette.background.default,
        backgroundImage: 'initial',
    },
    "& .MuiDialogContent-root": {
        padding: "0 8px 48px 8px",
        overflowY: 'auto',
        maxHeight: window.innerHeight - 72
    }
}));
export const ThemedDialogActions = styled(DialogActions)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.body2), { paddingBottom: isIOS ? '8px' : '8px', backgroundColor: theme.palette.background.default, width: '100%', borderTop: '#ccc 1px solid', borderBottom: '#ccc 1px solid', "@media (max-width: 600px)": {
        position: 'fixed',
        bottom: 0,
        zIndex: 2
    }, [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-start'
    } })));
export const ThemedTextFieldElement = styled(TextFieldElement, {
    shouldForwardProp: (prop) => !['forceIntegrated'].includes(prop),
})(({ theme, forceIntegrated }) => {
    return (Object.assign({}, theme.typography.body2));
});
export const ThemedTextField = styled(TextField)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedSelectElement = styled(SelectElement)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedAutocomplete = styled(Autocomplete)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedDatePickerElement = styled(DatePickerElement)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedTextareaAutosizeElement = styled(TextareaAutosizeElement)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedPasswordElement = styled(PasswordElement)(({ theme }) => (Object.assign({}, theme.typography.body2)));
export const ThemedDivider = styled(Divider)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.body2), { color: theme.palette.text.secondary, WebkitTextFillColor: theme.palette.text.secondary, fontWeight: 'bold', fontSize: '1rem', lineHeight: '1.5' })));
export const Item = styled(Box)(({ theme }) => (Object.assign(Object.assign({ backgroundColor: theme.palette.background.default }, theme.typography.body2), { padding: theme.spacing(1), color: theme.palette.text.secondary })));
export const ThemedAlert = styled(Alert)(({ theme }) => ({}));
export const ThemedFormContainer = styled(Box)(({ theme }) => ({
    paddingTop: 1
}));
export const GroupHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.mode === 'light'
        ? lighten(theme.palette.primary.light, 0.85)
        : darken(theme.palette.primary.main, 0.8)
}));
export const GroupItems = styled('ul')({
    padding: 0
});
